import React, { useEffect, useCallback, useState, useMemo } from 'react';

import Traductor from '../Traductor';
import Button from '../bronson/Button';
import {
    filterAgrupations,
    filterBrands,
    filterModels,
    filterKm,
    filterTransmission,
    filterEnergies,
    filterZones,
    filterPowerMax,
    filterPriceMax,
    filterFavorite,
    filterBidden,
    filterPlate,
    filterRegistrationDate,
    filterStates,
    filterBuyer,
    filterDatePurchaseFrom,
    filterDatePurchaseTo,
    filterComercialProducts,
    filterDealers,
    filterVIN,
    filterDatePurchaseOptionFrom,
    filterDatePurchaseOptionTo,
    filterWarrantyExtension,
    filterFinancialOperation,
    filterTransportState,
} from '../../constants/Filters';
import { checkFilterAvailable } from '../../js/filterFunctions';
import BrandFilter from './BrandFilter';
import ListFilter from './ListFilter';
import RangeFilter from './RangeFilter';
import ButtonGroupFilter from './ButtonGroupFilter';
import InputFilter from './InputFilter';
import DatesFilter from './BuyDatesFilters';
import ToggleFilter from './ToggleFilter';
import { disableHTMLOverflow } from '../../Functions';

import { withCookies } from 'react-cookie';
import ParseService from '../../services/ParseService';
import VehicleService from '../../services/VehicleService';
import '../../css/components/vehicleFilters/advancedFilters.css';
import Globals from '../../Globals';

const AdvancedFilters = ({
    cookies,
    refreshFilters,
    filters,
    filtersOptions,
    countSelectedFilters,
    updateFilters,
    setInitialFilters,
    closeAdvancedFilters,
    resetFilters,
    availableFilters,
}) => {
    const t = new Traductor();
    const containerType = 'advanced';
    const [temporaryFilters, setTemporaryFilters] = useState(filters);

    useEffect(() => {
        disableHTMLOverflow(true);
        if (document.body.clientWidth <= 768)
            window.bronson.$$('.js-accordion').component('accordion');
    }, []);

    useEffect(() => {
        setTemporaryFilters(filters);
        //UPDATE LOCAL FILTERS TO MATCH REDUX FILTERS ON RESET FILTERS
    }, [filters]);

    const getModels = useCallback(
        brands => {
            if (brands && brands.length > 0) {
                new VehicleService()
                    .getModels(
                        cookies.get(Globals.COOKIES.JWT).AccessToken,
                        brands
                    )
                    .then(response => {
                        setInitialFilters({
                            options: {
                                Models: new ParseService().Parse(
                                    response.body.Result
                                ),
                            },
                        });
                    });
            }
        },
        [cookies]
    );

    useEffect(() => {
        if (temporaryFilters?.filterBrands?.length) {
            getModels(temporaryFilters.filterBrands);
        }
    }, [temporaryFilters.filterBrands[0]]);

    const dateRangeFilterOptions = {
        id: 'dateRangeFilterAdvanced',
        step: 1,
        range: [
            filtersOptions.RegistrationDate
                ? filtersOptions.RegistrationDate[0]
                : 0,
            filtersOptions.RegistrationDate
                ? filtersOptions.RegistrationDate[1]
                : 1,
        ],
        labelClass: '',
        type: ['small'],
        tooltips: false,
        customValues: true,
        isDate: true,
    };

    const optionsSubmitAdvancedFilters = {
        text: t.getTraduction(
            'ApplyFilters'
        ) /* +
            ' ' +
            (countSelectedFilters > 0 ? '(' + countSelectedFilters + ')' : '') */,
        class: 'c-advanced-filters__btn-submit',
    };

    const optionsResetAdvancedFilters = {
        text: t.getTraduction('ResetFilters'),
        btnTypes: ['secondary'],
        class: 'c-advanced-filters__btn-reset',
    };

    const myVehiclesButtonGroup = [
        {
            Id: filterFavorite,
            Name: 'advanced_' + filterFavorite,
            Description: t.getTraduction('Favourits'),
        },
        {
            Id: filterBidden,
            Name: 'advanced_' + filterBidden,
            Description: t.getTraduction('Bids'),
        },
    ];

    const checkFilterAvailableCall = useCallback(
        filterName => {
            return checkFilterAvailable(availableFilters, filterName);
        },
        [availableFilters]
    );

    const selectFilter = useCallback(
        (name, code, isMultiSelect) => {
            const filterValue = temporaryFilters[name];
            let newFilerValue;

            if (filterValue) {
                if (isMultiSelect) {
                    if (filterValue.indexOf(code) > -1) {
                        newFilerValue = filterValue.filter(e => e !== code);
                    } else {
                        newFilerValue = [...filterValue, code];
                    }
                } else {
                    if (filterValue.indexOf(code) > -1) {
                        newFilerValue = [];
                    } else {
                        newFilerValue = [code];
                    }
                }
                let newFilters = {
                    ...temporaryFilters,
                    [name]: newFilerValue,
                };
                if (name === filterBrands) {
                    if (!newFilerValue.length) {
                        newFilters = {
                            ...newFilters,
                            filterModels: [],
                        };
                        setInitialFilters({ options: { Models: [] } });
                    }
                }
                setTemporaryFilters(newFilters);
            }
        },
        [setInitialFilters, temporaryFilters]
    );

    const printKmsFilter = () => {
        if (
            checkFilterAvailableCall(filterKm) &&
            filtersOptions.KmsMax &&
            filtersOptions.KmsMax.length > 0
        ) {
            const kmRangeFilterOptions = {
                id: 'kmRangeFilterAdvanced',
                step: 1000,
                range: [filtersOptions.KmsMax[0], filtersOptions.KmsMax[1]],
                labelClass: '',
                type: ['small'],
                tooltips: false,
                customValues: true,
                isDate: false,
            };

            return (
                <RangeFilter
                    filterTitle={t.getTraduction('Kms')}
                    filterCode={filterKm}
                    filters={temporaryFilters}
                    updateFilters={setTemporaryFilters}
                    rangeFilterOptions={kmRangeFilterOptions}
                />
            );
        } else {
            return null;
        }
    };

    const printPowerFilter = () => {
        if (
            checkFilterAvailableCall(filterPowerMax) &&
            filtersOptions.PowerMax &&
            filtersOptions.PowerMax.length > 0
        ) {
            const powerRangeFilterOptions = {
                id: 'powerRangeFilterAdvanced',
                step: 10,
                pips: filtersOptions.PowerMax[1],
                range: [filtersOptions.PowerMax[0], filtersOptions.PowerMax[1]],
                labelClass: '',
                type: ['small'],
                tooltips: false,
                customValues: true,
                isDate: false,
            };

            return (
                <RangeFilter
                    filterTitle={t.getTraduction('Power')}
                    filterCode={filterPowerMax}
                    filters={temporaryFilters}
                    updateFilters={setTemporaryFilters}
                    rangeFilterOptions={powerRangeFilterOptions}
                />
            );
        } else {
            return null;
        }
    };

    const printPriceFilter = () => {
        if (
            checkFilterAvailableCall(filterPriceMax) &&
            filtersOptions.PriceMax &&
            filtersOptions.PriceMax.length > 0
        ) {
            const priceRangeFilterOptions = {
                id: 'priceRangeFilterAdvanced',
                step: 500,
                range: [filtersOptions.PriceMax[0], filtersOptions.PriceMax[1]],
                labelClass: '',
                type: ['small'],
                tooltips: false,
                customValues: true,
                isDate: false,
            };

            return (
                <RangeFilter
                    filterTitle={t.getTraduction('Price')}
                    filterCode={filterPriceMax}
                    filters={temporaryFilters}
                    updateFilters={setTemporaryFilters}
                    rangeFilterOptions={priceRangeFilterOptions}
                />
            );
        } else {
            return null;
        }
    };

    const printModelFilters = () => {
        if (!filtersOptions?.Models?.length) return null;
        return (
            <ListFilter
                filterTitle={t.getTraduction('Modelos')}
                itemList={filtersOptions?.Models}
                filterName={filterModels}
                filters={temporaryFilters}
                selectFilter={selectFilter}
                isMultiSelect={true}
            />
        );
    };

    const closeModal = useCallback(() => {
        disableHTMLOverflow(false);
        closeAdvancedFilters();
    }, [closeAdvancedFilters]);

    const submitAdvancedFilters = useCallback(() => {
        refreshFilters(temporaryFilters);
        closeModal();
    }, [closeModal, refreshFilters, temporaryFilters]);

    const getListFilter = (
        traduction,
        itemList = [],
        filterName,
        isMultiSelect = false
    ) => {
        return (
            <ListFilter
                filterTitle={traduction}
                itemList={itemList}
                filterName={filterName}
                filters={temporaryFilters}
                selectFilter={selectFilter}
                showImages={true}
                isMultiSelect={isMultiSelect}
                filterContainer={containerType}
            />
        );
    };

    const getToggleFilter = (traduction, filterName, options) => {
        return (
            <ToggleFilter
                filterTitle={traduction}
                filterName={filterName}
                filters={temporaryFilters}
                updateFilters={setTemporaryFilters}
                options={options}
                filterContainer={containerType}
            />
        );
    };

    const getInputFilter = (traduction, filterName) => {
        if (!checkFilterAvailableCall(filterName)) return null;
        return (
            <InputFilter
                filterTitle={traduction}
                filterCode={filterName}
                filters={temporaryFilters}
                updateFilters={setTemporaryFilters}
                containerType={containerType}
            />
        );
    };

    const accordionRender = () => {
        if (window.innerWidth < 720) {
            setTimeout(function () {
                window.bronson.ComponentRegister.initAll();
            }, 0);
            return 'c-accordion  js-accordion  js-is-fx';
        } else {
            return '';
        }
    };

    const optionsDatePurchaseOption = useMemo(
        () => ({
            filterFrom: filterDatePurchaseOptionFrom,
            filterTo: filterDatePurchaseOptionTo,
            filterView: 'default',
            infinite: filtersOptions?.infinite,
            Months: filtersOptions.Months,
        }),
        [filtersOptions.infinite, filtersOptions.Months]
    );

    const optionsDatePurchase = useMemo(
        () => ({
            filterFrom: filterDatePurchaseFrom,
            filterTo: filterDatePurchaseTo,
            filterView: 'default',
            infinite: filtersOptions?.infinite,
            Months: filtersOptions.Months,
        }),
        [filtersOptions.infinite, filtersOptions.Months]
    );

    return (
        <div
            className="c-modal c-modal--left c-modal--advanced-filters js-modal--advanced-filter c-vehicle-filters--advanced"
            aria-hidden="false"
            id="demo-modal"
        >
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div className="c-modal__wrapper" role="dialog">
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper">
                        <p className="u-h4 c-modal__title">
                            {window.innerWidth >= 720
                                ? t.getTraduction('AdvancedFilters')
                                : t.getTraduction('Filters')}
                        </p>
                    </div>
                    <button
                        className="c-modal__close-btn  js-modal-close"
                        onClick={closeModal}
                        type="button"
                        aria-label="Cerrar modal."
                    ></button>
                </header>
                <div className="c-modal__content" role="document">
                    <div
                        className={accordionRender()}
                        data-accordion-multiple="true"
                    >
                        {checkFilterAvailableCall(filterFavorite) ? (
                            <ButtonGroupFilter
                                filterTitle={t.getTraduction('MyVehicles')}
                                filterName="myVehicles"
                                filtersInfo={myVehiclesButtonGroup}
                                filters={temporaryFilters}
                                updateFilters={setTemporaryFilters}
                            />
                        ) : null}
                        {checkFilterAvailableCall(
                            filterAgrupations,
                            'Agrupations'
                        )
                            ? getListFilter(
                                  t.getTraduction('Subastas'),
                                  filtersOptions.Agrupations,
                                  filterAgrupations,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(
                            filterComercialProducts,
                            'Products'
                        )
                            ? getListFilter(
                                  t.getTraduction('ComercialProducts'),
                                  filtersOptions.Products,
                                  filterComercialProducts,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterDealers, 'Dealers')
                            ? getListFilter(
                                  filtersOptions?.labels?.[filterDealers] ||
                                      t.getTraduction('ReturnDealers'),
                                  filtersOptions.Dealers,
                                  filterDealers,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterBrands) &&
                        filtersOptions?.Brands?.length ? (
                            <BrandFilter
                                filterTitle={t.getTraduction('Brands')}
                                itemList={filtersOptions.Brands}
                                filterName={filterBrands}
                                filters={temporaryFilters}
                                selectFilter={selectFilter}
                                showImages={true}
                                isMultiSelect={false}
                            />
                        ) : null}
                        {printModelFilters()}
                        {printKmsFilter()}
                        {checkFilterAvailableCall(
                            filterTransmission,
                            'Transmission'
                        )
                            ? getListFilter(
                                  t.getTraduction('Transmission'),
                                  filtersOptions.Transmission,
                                  filterTransmission,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterEnergies, 'Energies')
                            ? getListFilter(
                                  t.getTraduction('Energies'),
                                  filtersOptions.Energies,
                                  filterEnergies,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterZones, 'Zones')
                            ? getListFilter(
                                  t.getTraduction('Zones'),
                                  filtersOptions.Zones,
                                  filterZones,
                                  true
                              )
                            : null}
                        {printPowerFilter()}
                        {printPriceFilter()}
                        {checkFilterAvailableCall(filterRegistrationDate) ? (
                            <RangeFilter
                                filterTitle={t.getTraduction(
                                    'MatriculationYear'
                                )}
                                filterCode={filterRegistrationDate}
                                filters={temporaryFilters}
                                updateFilters={setTemporaryFilters}
                                rangeFilterOptions={dateRangeFilterOptions}
                            />
                        ) : null}
                        {checkFilterAvailableCall(filterStates, 'States')
                            ? getListFilter(
                                  t.getTraduction('States'),
                                  filtersOptions.States,
                                  filterStates,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterTransportState)
                            ? getListFilter(
                                  t.getTraduction('Transport'),
                                  filtersOptions.Transports,
                                  filterTransportState,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterBuyer, 'Buyers')
                            ? getListFilter(
                                  t.getTraduction('Compradores'),
                                  filtersOptions.Buyers,
                                  filterBuyer,
                                  true
                              )
                            : null}
                        {checkFilterAvailableCall(filterPlate)
                            ? getInputFilter(
                                  t.getTraduction('Plate'),
                                  filterPlate
                              )
                            : null}
                        {checkFilterAvailableCall(filterVIN)
                            ? getInputFilter(t.getTraduction('VIN'), filterVIN)
                            : null}
                        {checkFilterAvailableCall(filterFinancialOperation)
                            ? getInputFilter(
                                  t.getTraduction('FinancialOperation'),
                                  filterFinancialOperation
                              )
                            : null}
                        {checkFilterAvailableCall(filterDatePurchaseFrom) ? (
                            <DatesFilter
                                filterTitle={
                                    filtersOptions?.labels?.[
                                        filterDatePurchaseFrom
                                    ] || t.getTraduction('BuyDate')
                                }
                                filters={temporaryFilters}
                                updateFilters={setTemporaryFilters}
                                options={optionsDatePurchase}
                            />
                        ) : null}
                        {checkFilterAvailableCall(
                            filterDatePurchaseOptionFrom
                        ) ? (
                            <DatesFilter
                                filterTitle={
                                    filtersOptions?.labels?.[
                                        filterDatePurchaseOptionFrom
                                    ] || t.getTraduction('PurchaseOptionDate')
                                }
                                filters={temporaryFilters}
                                updateFilters={setTemporaryFilters}
                                options={optionsDatePurchaseOption}
                            />
                        ) : null}
                        {checkFilterAvailableCall(filterWarrantyExtension)
                            ? getToggleFilter(
                                  t.getTraduction('ValidWarrantyExtension'),
                                  filterWarrantyExtension,
                                  {
                                      rightText: t.getTraduction(
                                          'WithValidWarrantyExtension'
                                      ),
                                  }
                              )
                            : null}
                    </div>
                </div>
                <div className="c-modal__footer c-advanced-filters__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <Button
                                options={optionsResetAdvancedFilters}
                                onClick={resetFilters}
                            />
                        </div>
                        <div className="c-modal__actions__item">
                            <Button
                                options={optionsSubmitAdvancedFilters}
                                onClick={submitAdvancedFilters}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withCookies(AdvancedFilters);
